<template>
  <Card class="mb-3">
    <LocalDataTable :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
export default {
  name: "TicketList",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      ajaxLink : 'admin/Ticket/List',
      columns : [
        {title : 'شماره'},
        {title : 'کاربر'},
        {title : 'آخرین به روزرسانی'},
        {title : 'وضعیت'},
        {title : 'عملیات',sortable : false},
      ]
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('تیکت ها');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>